var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "500px",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { outline: "", dark: "", loading: _vm.loadingDeleteN },
                  on: {
                    click: function($event) {
                      return _vm.remover("0", close)
                    }
                  }
                },
                [_vm._v(" Manter histórico ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { alert: "", loading: _vm.loadingDeleteY },
                  on: {
                    click: function($event) {
                      return _vm.remover("1", close)
                    }
                  }
                },
                [_vm._v(" Excluir tudo ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "remover-produto pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [_vm._v("Excluir ativo")])
        ]),
        _c("div", { staticClass: "modal-content" }, [
          _c("p", [_vm._v("Escolha o que fazer com o histórico deste ativo:")]),
          _c(
            "div",
            { staticClass: "remover-produto__opcao" },
            [
              _c("icon-svg", {
                attrs: { name: "mdi-history", size: 18, color: "#8E8E8E" }
              }),
              _c("div", [
                _c(
                  "span",
                  { staticClass: "remover-produto__rotulo" },
                  [
                    _c("strong", [_vm._v("Manter histórico")]),
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", "max-width": "320" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "icon-svg",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          name: "mdi-information",
                                          size: "14",
                                          color: "#8E8E8E"
                                        }
                                      },
                                      "icon-svg",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " Use quando a posição foi encerrada de verdade: o cliente vendeu, resgatou ou o título venceu. A rentabilidade do período continua correta, porque o histórico fica. "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(
                  " A posição é zerada e o ativo continua na carteira com saldo R$ 0,00. Os aportes e resgates continuam no extrato e seguem contando na rentabilidade. Em alguns tipos, pediremos o preço final antes de concluir. "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "remover-produto__opcao" },
            [
              _c("icon-svg", {
                attrs: {
                  name: "mdi-delete-outline",
                  size: 18,
                  color: "#8E8E8E"
                }
              }),
              _c("div", [
                _c(
                  "span",
                  { staticClass: "remover-produto__rotulo" },
                  [
                    _c("strong", [_vm._v("Excluir tudo")]),
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", "max-width": "320" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "icon-svg",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          name: "mdi-information",
                                          size: "14",
                                          color: "#8E8E8E"
                                        }
                                      },
                                      "icon-svg",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " Use quando o ativo foi cadastrado por engano e nunca existiu na carteira. Se ele existiu de verdade, apagar o histórico distorce a rentabilidade do período. "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(
                  " O ativo e todo o histórico (aportes, resgates, proventos e eventos) são apagados permanentemente. Não é possível desfazer. "
                )
              ])
            ],
            1
          ),
          !_vm.isCliente
            ? _c("p", { staticClass: "az-text-small mt-4" }, [
                _vm._v(
                  ' Para tirar o ativo apenas do cálculo de rentabilidade, sem perder nada, use "Desconsiderar na rentabilidade" nas ações em lote. '
                )
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }